import React from 'react';
import { Box } from '@mui/material';
import { 
  DetailSection, 
  SectionTitle, 
  WorkerContainer, 
  WorkerAvatar, 
  WorkerName, 
  WorkerDetailText 
} from './styles';

interface WorkerAssignedProps {
  name: string;
  workerId: string;
  role: string;
  avatarUrl?: string;
}

const WorkerAssigned: React.FC<WorkerAssignedProps> = ({ name, workerId, role, avatarUrl }) => {
  return (
    <DetailSection>
      <SectionTitle>Worker Assigned</SectionTitle>
      <WorkerContainer>
        <WorkerAvatar src={avatarUrl} alt={name} />
        <Box>
          <WorkerName>{name}</WorkerName>
          <WorkerDetailText>ID: {workerId}</WorkerDetailText>
          <WorkerDetailText>Role: {role}</WorkerDetailText>
        </Box>
      </WorkerContainer>
    </DetailSection>
  );
};

export default WorkerAssigned;
